import React, { useEffect, useState } from "react";
import ServicesMapView from "../sections/CustomerSupport/ServicesMapView";
import WhyTradesposter from "../sections/CustomerSupport/WhyTradesposter";
import SatisfiedClients from "../sections/CustomerSupport/SatisfiedClients";
import Banner from "../components/common/Banners/Banner";
import MainButton from "../components/common/MainButton/MainButton";
import Login from "../sections/Login/Login";
import { SignUp as SignUpRegister } from "../sections/SignUp/SignUp";
import HireWithConf from "../sections/CustomerSupport/HireWithConf";
import HelpSupport from "../sections/CustomerSupport/HelpSupport";
import ImageWithTopText from "../components/common/Generics/ImageWithTopText";
import FullLengthSlider from "../sections/AllServicesSlider/FullLengthSlider";
import {
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS,
  PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS,
} from "../sections/Public/shared/publicLayoutSpec";
import CustomerSupportFAQs from "../components/common/PricingFAQs/CustomerSupportFAQs";
import CustomerSupportBanner from "../components/common/Banners/CustomerSupportBanner";
import gsap from "gsap";
import { useRef } from "react";
import CustomerFeaturePoints from "../sections/CustomerSupport/CustomerFeaturePoints";
import CustomerFounderMessage from "../sections/CustomerSupport/CustomerFounderMessage";
import CustomerCoFounderMessage from "../sections/CustomerSupport/CustomerCoFounderMessage";

const CustomerSupport = () => {
  const [SignUp, setSignUp] = useState(false);
  const [SignIn, setSignIn] = useState(false);
  useEffect(() => {
    if (SignUp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }
  }, [SignUp]);
  const buttonWrapperRef = useRef(null);
  useEffect(() => {
    if (buttonWrapperRef.current) {
      gsap.set(buttonWrapperRef.current, { opacity: 0, y: 60 });
      gsap.to(buttonWrapperRef.current, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        delay: 0.3,
      });
    }
  }, []);
  return (
    <>
      <CustomerSupportBanner
        headingClasses={
          "text-center sm:text-center text-white xl:w-[900px] 2xl:w-[1000px] mx-auto"
        }
        heading={
          "Get the Job Done with Real Trade Businesses"
        }
        className={"bg-about"}
      >
        {/* <div ref={buttonWrapperRef}>
          <MainButton
            variant={"extralarge"}
            className={"mt-10"}
            onClick={() => setSignUp(true)}
          >
            Customer Sign Up
          </MainButton>
        </div> */}
        {SignIn && (
          <Login
            SignIn={SignIn}
            setSignIn={setSignIn}
            SignUpState={SignUp}
            setSignUpState={setSignUp}
          />
        )}
        {SignUp && (
          <SignUpRegister
            SignUpState={SignUp}
            setSignUpState={setSignUp}
            SignIn={SignIn}
            setSignIn={setSignIn}
          />
        )}
      </CustomerSupportBanner>
      <WhyTradesposter />
      <CustomerFeaturePoints />
      {/* <ImageWithTopText
        classNames={
          "mx-[5%] xl:mx-auto h-[500px] sm:h-auto xl:w-[1100px] 2xl:w-[1264px] 2xl:h-[700px] sm:aspect-[1264/700]"
        }
        TopText={
          "Get started by setting up your profile"
        }
      />*/}
      {/* <ImageWithTopText
        classNames={
          "mx-[5%] xl:mx-auto h-[500px] sm:h-auto xl:w-[1100px] 2xl:w-[1264px] 2xl:h-[700px] sm:aspect-[1264/700]"
        }
        TopText={
          "Browse, Connect, and Review"
        }
      /> */}
      
      <ServicesMapView />
      <ImageWithTopText
        classNames="h-[500px] sm:h-auto sm:aspect-[1440/900] 2xl:h-[800px]"
        TopText="Easily Connect with Businesses"
      />
      <SatisfiedClients />
      {/* <HireWithConf /> */}
      <CustomerSupportFAQs />
      <HelpSupport />
      <FullLengthSlider
        className={PUBLIC_SECTION_GAP_CLASS}
        itemGapClassName={PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS}
        labelClassName={PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS}
      />
    </>
  );
};

export default CustomerSupport;
